const certifications = [
    {
        id: 7,
        title: "React JS For Beginners",
        image: "/icons/certificates/react-js.jpg",
        url: "https://simpli-web.app.link/e/YkXOfmCZXUb"
    },
    {
        id: 6,
        title: "Data Science Foundation Assessment",
        image: "/icons/certificates/Data-Science-Foundation-test.jpg",
        url: ""
    },
    {
        id: 5,
        title: "Introduction to Tableau",
        image: "/icons/certificates/Intro-to-Tableau.jpg",
        url: "https://simpli-web.app.link/e/T6FjOzHHCTb"
    },
    {
        id: 4,
        title: "Get Started with Node JS ",
        image: "/icons/certificates/node-js.jpg",
        url: "https://simpli-web.app.link/e/MihAk0RHCTb"
    },
    {
        id: 3,
        title: "Gen AI & RAG workshop",
        image: "/icons/certificates/gen-ai-&-rag-workshop.jpg",
        url: ""
    },
    {
        id: 2,
        title: "Machine Learning Intern",
        image: "/icons/certificates/IC-internship.jpg",
        url: ""
    },
    {
        id: 1,
        title: "Hackz'24 Final Round",
        image: "/icons/certificates/Hackz-final-round.jpg",
        url: ""
    },
];

export default certifications;